import Text from '@components/Text';
import colors from '@constants/colors';
import styled from '@emotion/styled';
import { ReactNode } from 'react';

import ArrowIcon from './ArrowIcon';
import useSlideHandle, { HANDLE_WIDTH } from './hooks/useSlideHandle';
import useWidth from './hooks/useWidth';

interface Props {
    children?: ReactNode;
    onConfirm?: () =>void;
    width?: number | string;
}

const SIZE = 56;

function SlideBar({ children, onConfirm, width = '100%' }:Props) {
    const { width: containerWidth, ref } = useWidth();
    const {
        percent, handleTouchEnd, handleTouchStart, handleTouchMove,
        isMoveEnd, translateX,
    } = useSlideHandle({
        containerWidth, onConfirm,
    });
    return (
        <Container ref={ref}
            style={{ width }} >
            <Text color={colors.gray5}
                size='2xl'
                fontWeight='bold'>
                {children}
            </Text>
            <ProgressWrapper isMoveEnd={isMoveEnd}
                style={{ width: `calc(${percent * 100}%  + ${HANDLE_WIDTH / 2}px)` }} >
                <Progress style={{ width: containerWidth }} >
                    <Text color={colors.buttonText}
                        size='2xl'
                        fontWeight='bold'>
                        {children}
                    </Text>
                </Progress>
            </ProgressWrapper>
            <Handle isMoveEnd={isMoveEnd}
                style={{
                    transform: `translateX(${translateX}px)`,
                }}
                onTouchStart={handleTouchStart}
                onTouchMove={handleTouchMove}
                onTouchEnd={handleTouchEnd} >
                <ArrowIcon/>
            </Handle>
        </Container>
    );
}

const Container = styled.div`
    align-items: center;
    background-color: var(--color-gray3);
    border-radius: 20px;
    display: flex;
    height: ${SIZE}px;
    justify-content: center;
    overflow: hidden;
    position: relative;
`;

const Progress = styled.div`
    align-items: center;
    background-color: var(--color-primary);
    border-radius: 20px;
    display: flex;
    height: 100%;
    justify-content: center;
    width: 100%;
`;

const ProgressWrapper = styled.div<{
    isMoveEnd?: boolean;
}>`
    height: 100%;
    left: 0;
    overflow: hidden;
    position: absolute;
    ${({ isMoveEnd }) => isMoveEnd && 'transition: 150ms linear;'}
`;

const Handle = styled.div<{
    isMoveEnd?: boolean;
}>`
    align-items: center;
    background-color: var(--color-primary);
    border-radius: 20px;
    box-shadow: -1px 0 1px 0 rgba(0, 0, 0, 0.25);
    display: flex;
    height: ${SIZE}px;
    justify-content: center;
    left: 0;
    position: absolute;
    width: ${SIZE}px;
    ${({ isMoveEnd }) => isMoveEnd && 'transition: 150ms linear;'}
`;

export default SlideBar;
